import React from 'react';
import PropTypes from 'prop-types';
import { cloneNthChildren } from '@beef/react';
import { assertArrayValue } from "./utils";
import { enhancedConnect } from "../../../enhancedConnect";
import { CrudeProvider } from "../CrudeContext";
var _CrudeMapper = function _CrudeMapper(_ref) {
  var alias = _ref.alias,
    value = _ref.value,
    children = _ref.children,
    _ref$skipChildren = _ref.skipChildren,
    skipChildren = _ref$skipChildren === void 0 ? 0 : _ref$skipChildren;
  value = assertArrayValue(value);
  return cloneNthChildren(children, skipChildren, function (nthChildren) {
    return value.map(function (item, index) {
      return /*#__PURE__*/React.createElement(CrudeProvider, {
        alias: alias,
        extra: {
          number: index + 1,
          index: index
        },
        key: +index,
        value: item,
        "data-t-id": "components-CrudeMapper"
      }, nthChildren);
    });
  });
};

/**
 *
 * @param alias - короткое название для данных, которые будут доступны по $$.{alias}.*
 * @param value - массив данных, на основании которых будет производиться маппинг
 * @param children
 * @param skipChildren - число уровней вложения, которые необходимо пропустить, по умолчанию - 0.
 *   Обычно это нужно, чтобы не устанавливать маппер между компонентом и его дочерними элементами
 */
export var CrudeMapper = enhancedConnect({
  children: PropTypes.node,
  alias: PropTypes.string,
  value: PropTypes.string,
  skipChildren: PropTypes.number
})(_CrudeMapper);